"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCombinedRefs = void 0;

var _react = _interopRequireDefault(require("react"));

var _useLayoutEffectSSRSafe = require("./useLayoutEffectSSRSafe");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// https://itnext.io/reusing-the-ref-from-forwardref-with-react-hooks-4ce9df693dd
var useCombinedRefs = function useCombinedRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  var targetRef = _react["default"].useRef();

  (0, _useLayoutEffectSSRSafe.useLayoutEffectSSRSafe)(function () {
    refs.forEach(function (ref) {
      if (!ref) {
        return;
      }

      if (typeof ref === 'function') {
        ref(targetRef.current);
      } else {
        ref.current = targetRef.current;
      }
    });
  }, refs);
  return targetRef;
};

exports.useCombinedRefs = useCombinedRefs;